<template>
  <div
    class="p-field p-d-flex"
    :style='rootStyle'
    :class="{ 'p-flex-column': !directionRow, 'direction-row': directionRow }"
  >
    <label
      v-if="label"
      :class="{
        'p-error': !!errorMessage,
        'p-focus': focus_status && !errorMessage,
      }"
      :for="id"
    >
      {{ label }}
    </label>
    <div class="p-d-flex p-flex-column span-container">
      <span
        :class="{
          'p-input-icon-left': iconClass != undefined && !iconRight,
          'p-input-icon-right': iconClass != undefined && iconRight,
        }"
      >
        <i v-if="iconClass != undefined" :class="iconClass" />
        <InputText
          :disabled="disabled"
          :id="id"
          :name="name"
          :class="[!!errorMessage ? 'p-invalid' : '', inputClass, errorMessage ? 'p-input-error': '']"
          :placeholder="placeholder"
          :modelValue="text.value"
          v-model="text.value"
          @input="onInput"
          :type="type"
          @focus="focus_status = true"
          @blur="focus_status = false"
          :style="style"
          :readonly = "readonly"
          :step="step"
          :autocomplete="autocomplete"
          :aria-autocomplete="ariaAutocomplete"
          min="0"     />
      </span>
      <small v-if="displayError && !!errorMessage" :class="{ 'p-error': true }">
        {{ errorMessage }}</small>
    </div>
  </div>
</template>
<script>
// import InputText from "primevue/inputtext";
import { defineAsyncComponent } from 'vue'
const InputText = defineAsyncComponent(() =>
  import('primevue/inputtext')
)
import TBaseInput from "./TBaseInput";
import { ref } from "@vue/runtime-core";
import { reactive } from "@vue/reactivity";
import { watch } from "vue";
import { useField } from "vee-validate/dist/vee-validate.min.js";

export default {
  extends: TBaseInput,
  components: { InputText },

  setup(props, { emit }) {
    const { value, errorMessage } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

  
    
    const text = reactive({
      value: value,
    });

    watch(
      () => props.modelValue,
      (first, second) => {
        text.value = first;
      }
    );

    let onInput = (e) => {
      emit("update:modelValue", e.target.value);
      if (typeof props.onInputText === "function") {
        props.onInputText(e.target.value);
      }
      emit("input", e.target.value);
      if (props.onInputText) props.onInputText(e.target.value);
    };
    
    return {
      errorMessage,
      onInput,
      text,
    };
  },
  emits: ["input"],
  props: {
    displayError: { type: Boolean, default: true },
    onInputText: Function,
    type: String,
    disabled:{ type: Boolean, default: false },
    readonly:{ type: Boolean, default: false },
    autocomplete:{ type: String, default: 'on' },
    ariaAutocomplete:{ type: String, default: 'inline' },
    style: {},
    rootStyle:{},
    step:{type:String, default: "1"},
  },

}
</script>

<style lang="scss" scoped>
@import "./../../style/components/input-text/base-input.scss";
</style>
